import styled from '@emotion/styled';

const SkillIcon = styled.img`
  margin: 20px;
  width: ${props => props.width || 50}px;
  height: ${props => props.height || 50}px;
`;

export default SkillIcon;
